export default "__VITE_ASSET__Ilh$c16r__"